exports = module.exports = require("../../../../../../questiongroup/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image>img{display:block;margin:0 auto;max-width:100%;min-width:50px}", ""]);

// exports
